import React, { useMemo } from 'react';
import { gql } from '@soundxyz/gql-string';
import { styled } from '@components-shared/src/stitches';
import { ComponentContainer, FeaturedCollectorContainer } from '@components/Feed/shared';
import { PurchaseCard } from '@components/SongCards/PurchaseCard';
import {
  GridCarousel,
  SSR_SLIDE_WIDTH_DEFAULT_FEED,
} from '@components/main-components/carousel/GridCarousel';
import { MediaQuery } from '@context/mediaQuery';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment, ReleaseCollectedByManyActivityFragmentDoc } from '@graphql/reactQuery';
import { useWindowSize } from '@hooks/useWindowSize';
import { homePlaylist } from '@store/audio/AudioQueue';
import { ComponentWrapper } from '../UserCollectedManySongs';
import { UsersActivityDetail } from './UsersActivityDetail';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ReleaseCollectedByManyActivity on SongCollectedByManyAggregate {
    ...UsersActivityDetail
    collectedRelease {
      release {
        id
        ...PurchaseCard
        socialProofCollectors(userId: $userId) {
          id
          ...PurchaseCardCollectedByUser
        }
      }
    }
  }
`);

export const ReleaseCollectedByMany = ({
  activityFrag,
  activityId,
  timeStamp,
}: {
  activityFrag: FragmentType<ReleaseCollectedByManyActivityFragmentDoc>;
  activityId: string;
  timeStamp: number;
}) => {
  const activity = getFragment(ReleaseCollectedByManyActivityFragmentDoc, activityFrag);
  const { release } = activity.collectedRelease;
  const { tablet } = MediaQuery.useContainer();
  const slides = [
    {
      id: '1',
      slide: (
        <PurchaseCard
          releaseFrag={release}
          playlist={homePlaylist}
          collectedByFrag={activity.collectedRelease.release.socialProofCollectors}
        />
      ),
    },
  ];

  const { width: windowWidth } = useWindowSize();
  const columnAmount = useMemo(() => {
    if (windowWidth) {
      if (windowWidth >= 1280) return 3;
      if (windowWidth >= 768) return 3;
      if (windowWidth >= 640) return 2.5;
    } else {
      return 3;
    }
    return 1.5;
  }, [windowWidth]);

  return (
    <ComponentContainer>
      <FeaturedCollectorContainer>
        {!!activity && !!timeStamp && (
          <UsersActivityDetail
            activityFrag={activity}
            timeStamp={timeStamp}
            activityId={activityId}
          />
        )}
      </FeaturedCollectorContainer>

      {!!release && (
        <ComponentWrapper>
          {!tablet && <Mask />}
          <GridCarousel
            slides={slides}
            onEndReached={null}
            onInternalActiveIndexChange={null}
            columnAmount={columnAmount}
            hideArrows={false}
            externalActiveIndex={null}
            spacing={null}
            alignSlidesLeft={false}
            ssrSlideWidth={SSR_SLIDE_WIDTH_DEFAULT_FEED}
            columnType="large"
          />
        </ComponentWrapper>
      )}
    </ComponentContainer>
  );
};

export const Mask = styled('div', {
  opacity: 0.5,
  maskImage: 'url(/star.png)',
  maskSize: '34px',
  background:
    'radial-gradient(80% 100% at 5% 10%, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%), rgba(0,0,0, 0.5)',
  transform: 'rotate(180deg) matrix(-1, 0, 0, 1, 0, 0)',
  width: 280,
  height: 138,
  left: '50%',
  position: 'absolute',
  bottom: 0,
  marginLeft: 12,
});
